export default {"src":"/_next/static/media/forbesIcon.f4560acb.svg","height":88,"width":118};